import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _isValidNumberForRegion from '../es6/legacy/isValidNumberForRegion.js'

export function isValidNumberForRegion() {
	return withMetadataArgument(_isValidNumberForRegion, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/isValidNumberForRegion.js
// module id = 1604
// module chunks = 0